import * as React from "react";
import { cn } from "@/lib/utils";

export interface SwitchProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  name?: string;
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  (
    { className, checked = false, onCheckedChange, disabled, ...props },
    ref
  ) => {
    return (
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled ? "true" : "false"}
        data-state={checked ? "checked" : "unchecked"}
        onClick={() => {
          if (disabled) return;
          onCheckedChange?.(!checked);
        }}
        disabled={disabled}
        ref={ref}
        className={cn(
          // track
          "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-all duration-200 ease-out",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          "disabled:cursor-not-allowed disabled:opacity-50",
          checked
            ? "bg-primary/90 shadow-inner ring-2 ring-primary/30 hover:ring-primary/40"
            : "bg-input shadow-inner hover:ring-1 hover:ring-border/40",
          className
        )}
        {...props}
      >
        {/* thumb */}
        <span
          className={cn(
            "pointer-events-none block h-5 w-5 rounded-full bg-background ring-1 transition-transform duration-200 ease-out will-change-transform",
            checked
              ? "translate-x-5 shadow-[0_4px_10px_rgba(0,0,0,0.28)] ring-black/10"
              : "translate-x-0 shadow-[0_2px_6px_rgba(0,0,0,0.22)] ring-black/5"
          )}
        />
      </button>
    );
  }
);

Switch.displayName = "Switch";
